import { CompletionCriterion, CourseWizardData } from "../types";

const dateOnlyOrNull = (d: string | null | undefined): string | null => {
  if (!d) return null;
  return d.split("T")[0];
};

const todayISODate = (): string => {
  const d = new Date();
  const utcMs = Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0);
  return new Date(utcMs).toISOString().split("T")[0];
};

const completionFieldByCriterion = (
  criterion: CompletionCriterion | null,
): string | null => {
  switch (criterion) {
    case "LO_TO_COMPLETE":
      return "lo_to_complete";
    case "MIN_COMPLETION_PERC":
      return "min_completition_perc";
    case "COMPLETION_MINUTES":
      return "completition_minutes";
    case "COMPLETION_MINUTES_PERC":
      return "completition_minutes_perc";
    default:
      return null;
  }
};

export function mapWizardDataToCourseInputForm(
  data: CourseWizardData,
): Record<string, any> {
  const completionField = completionFieldByCriterion(data.completion_criterion);

  const inputForm: Record<string, any> = {
    //  Step 1 — info principali
    title: data.title || "",
    description: data.description || "",
    digited_code: data.digited_code || null,
    is_standalone: data.is_standalone,

    publish_date:
      data.is_standalone && !data.schedule_publication
        ? (dateOnlyOrNull(data.publish_date) ?? todayISODate())
        : dateOnlyOrNull(data.publish_date),
    obsolescent_date: dateOnlyOrNull(data.obsolescent_date),
    propaedeutic_logics: data.propaedeutic_logics || null,
    cover_id: data.cover_id ? Number(data.cover_id.id) : null,
    video_id: data.video_id ? Number(data.video_id.id) : null,

    completable: !data.allow_post_publish_additions,
    completable_flag: String(!data.allow_post_publish_additions),

    //  Step 2 — info aggiuntive
    didactical_material:
      data.didactical_material?.map((m) => Number(m.id)) ?? [],
    useful_links:
      data.useful_links && data.useful_links.length > 0
        ? data.useful_links
        : undefined,
    stakeholders: data.stakeholders ?? [],
    time_slots: data.time_slots ?? [],
    certificate_ids: data.certificate_ids?.map((c) => Number(c.id)) ?? [],
    signature_certificate_ids:
      data.signature_certificate_ids?.map((c) => Number(c.id)) ?? [],
    badge_id: data.badge_id ? Number(data.badge_id.id) : null,
    complexity: data.complexity || null,
    score: data.score === "" ? undefined : Number(data.score),
    credits: data.credits === "" ? undefined : Number(data.credits),
    lo_tag: data.lo_tag ?? [],

    //  Step 3 — attività didattiche
    didactical_activity: data.selected_activities.map((a) => Number(a.id)),

    //  Step 4 — test e survey
    test_id: data.test_id ? Number(data.test_id.id) : null,
    survey_id: data.survey_id ? Number(data.survey_id.id) : undefined,
    test_logic: data.test_logic || null,
    test_min_score:
      data.test_min_score === "" ? undefined : Number(data.test_min_score),
    max_attempt:
      data.max_attempt === "" ? null : Number(data.max_attempt) || null,

    //  Step 6 — highlight
    highlight_explore: data.highlight_explore,

    expiration_date_flag: false,
  };

  if (completionField) {
    inputForm[completionField] =
      data.completion_value === "" ? undefined : data.completion_value;
  }

  return inputForm;
}
